import { Box, Button, Modal } from "@amzn/awsui-components-react";
import * as React from "react";
import { useInstanceDataContext } from "../../../contexts/InstanceDataContext";

interface CrossInstanceRedirectModalProps {
    visible: boolean;
    currentInstanceId: string;
    targetInstanceId: string;
    onRedirect: () => void;
    onCancel: () => void;
}

export const CrossInstanceRedirectModal: React.FC<CrossInstanceRedirectModalProps> = ({
    visible,
    currentInstanceId,
    targetInstanceId,
    onRedirect,
    onCancel
}) => {
    const { getInstanceById } = useInstanceDataContext();

    const currentInstance = getInstanceById(currentInstanceId);
    const targetInstance = getInstanceById(targetInstanceId);

    const currentInstanceName = currentInstance?.name || currentInstanceId;
    const targetInstanceName = targetInstance?.name || targetInstanceId;

    return (
        <Modal
            header="You are being redirected"
            visible={visible}
            onDismiss={onCancel}
            size="medium"
            footer={
                <Box float="right">
                    <Button variant="link" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={onRedirect}>
                        Confirm
                    </Button>
                </Box>
            }
        >
            <div>
                You are leaving the <strong>{currentInstanceName}</strong> PathFinder site, you will be redirected to the <strong>{targetInstanceName}</strong> site.
            </div>
            <br />
            <div>
                <strong>Reminder:</strong> to change the current site, select the site name at the top of the page.
            </div>
            <br />
            <Box textAlign="center">
                <span className="nav-instance-name-action">{currentInstanceName}</span>
            </Box>

        </Modal>
    );
};
